export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
  case "ep.maot.co.kr":
    return "작업장명";
  case "nhsafe.maot.co.kr":
    return "현장명";
  default:
    return "사업장명";
  }
};

import config from "../../public/config";
import VueCookie from "vue-cookie";

export const downloadFile = (fileName, path) => {
  const hashedFileName = path.split("/").pop();

  const token = VueCookie.get("token");
  fetch(`${config.BASE_API_URL}/api/v1/file?hashedName=${hashedFileName}`, {
    headers: new Headers({
      Authorization: `Bearer ${token}`,
    }),
  }).then((response) => {
    response.blob().then((myBlob) => {
      const url = window.URL.createObjectURL(myBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });
  });
};
